import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { BusinessSettingsContext } from "../../context/BusinessSettingsContext";

const Profile = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const { settings } = useContext(BusinessSettingsContext);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const storedUser = localStorage.getItem("user");

        // If no token, redirect to Sign-in page
        if (!token || !storedUser) {
            navigate("/signin");
            return;
        }

        const userData = JSON.parse(storedUser);
        setUser(userData);
        setName(userData.name);
        setEmail(userData.email);
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        navigate("/signin"); // Redirect to Sign-in page
    };

    return (
        <main className="main">
            <div className="container-fluid">
                <div className="row row--grid">
                    <div className="col-12">
                        <div className="sign">
                            <div className="sign__content">
                                <form className="sign__form">
                                    <a href="/" className="sign__logo">
                                        <img src={ settings.website_logo || "Website Name" } alt=""/>
                                    </a>

                                    <h2 class="text-white" style={{ textAlign: "center" }}>User Profile</h2>

                                    {user ? (
                                        <>
                                            <div className="sign__group">
                                                <label class="text-white">Name</label>
                                                <input
                                                    type="text"
                                                    className="sign__input"
                                                    value={name}
                                                    disabled
                                                />
                                            </div>

                                            <div className="sign__group">
                                                <label class="text-white">Email</label>
                                                <input
                                                    type="text"
                                                    className="sign__input"
                                                    value={email}
                                                    disabled
                                                />
                                            </div>

                                            <button className="sign__btn" type="button" onClick={handleLogout}>
                                                Logout
                                            </button>
                                        </>
                                    ) : (
                                        <p>Loading...</p>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Profile;
